import styled, { css } from 'styled-components';

export const CardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  background: ${(props) => props.theme.colors?.white || '#FFFFFF'};
  border: 2px solid ${(props) => props.theme.colors?.border || '#E5E7EB'};
  border-radius: 12px;
  transition: all 0.2s ease;
  cursor: pointer;

  ${(props) =>
    props.$selected &&
    css`
      border-color: ${props.theme.colors?.primary || '#3B82F6'};
      background: ${props.theme.colors?.primaryLight || '#EFF6FF'};
    `}

  &:hover {
    border-color: ${(props) => props.$selected ? props.theme.colors?.primary || '#3B82F6' : props.theme.colors?.primaryHover || '#93C5FD'};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
`;

export const CheckboxWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding-top: 2px;
`;

export const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const TitleArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
`;

export const Title = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || '#111827'};
  margin: 0;
  line-height: 1.4;
`;

export const CategoryBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: ${(props) => props.$bgColor || '#E5E7EB'};
  color: ${(props) => props.$color || '#374151'};
`;

export const PinButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${(props) =>
    props.$isPinned
      ? '#155DFC'
      : props.theme.colors?.textSecondary || '#9CA3AF'};
  transition: color 0.15s ease;

  &:hover {
    color: #155DFC;
  }
`;

export const DescriptionArea = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || '#4B5563'};
  line-height: 1.55;
`;

export const DescriptionText = styled.span``;

export const ShowMoreButton = styled.button`
  display: inline;
  padding: 0;
  margin-left: 4px;
  background: none;
  border: none;
  color: ${(props) => props.theme.colors?.primary || '#3B82F6'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 4px;
`;

export const AuthorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AuthorAvatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors?.backgroundSecondary || '#E5E7EB'};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AuthorName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors?.text || '#111827'};
`;

export const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: ${(props) => props.theme.colors?.textTertiary || '#9CA3AF'};
`;

export const Separator = styled.span`
  color: ${(props) => props.theme.colors?.textTertiary || '#D1D5DB'};
  font-size: 10px;
`;

export const RightMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
`;

export const MetaIconItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
`;

export const ExpirationBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: ${(props) => props.$isExpired ? '#DC2626' : '#F59E0B'};
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background: ${(props) => props.$bgColor || '#F3F4F6'};
  color: ${(props) => props.$color || '#6B7280'};
  border: 1px solid ${(props) => props.$borderColor || 'transparent'};
`;
